import { useEffect, useState } from 'react';
import {
  EMPTY_BRANDING,
  getResolvedBranding,
  resolveBranding,
  type Branding,
} from '@/services/apis/branding.api';

/**
 * Loads the current tenant's sign-on branding. Seeds from the per-host cache so
 * screens that mount after the first resolve get the tenant's logo/cover
 * immediately (no EMPTY_BRANDING → tenant flash); otherwise resolves once.
 */
export function useBranding() {
  const hostname = window.location.hostname;
  const [branding, setBranding] = useState<Branding>(
    () => getResolvedBranding(hostname) ?? EMPTY_BRANDING
  );

  useEffect(() => {
    if (getResolvedBranding(hostname)) {
      return;
    }

    let isActive = true;
    void resolveBranding(hostname).then(result => {
      if (isActive) {
        setBranding(result);
      }
    });

    return () => {
      isActive = false;
    };
  }, [hostname]);

  return branding;
}
